import { apiAgent } from './apiService';

/**
 * Settings > Notifications: per-account email/push/sound preferences.
 * Trailing slash matches the backend route exactly (router prefix
 * "/notification-preferences" + "@router.get('/')"), avoiding a 307 redirect.
 */
export const notificationPreferenceService = {
  async get() {
    const response = await apiAgent.get('/notification-preferences/');
    return response.data;
  },

  async update(partial) {
    const response = await apiAgent.put('/notification-preferences/', partial);
    return response.data;
  },
};

export default notificationPreferenceService;
